<template>
  <div class="flow-wrap">
    <div class="flow-title">
      <span>近期日程</span>
      <div class="title-search">
        <div class="title-search-item">
          <el-date-picker
            v-model="scheduleData.date"
            type="monthrange"
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            value-format="yyyy-MM"
            :clearable="false"
            @change="getScheduleList"
          >
          </el-date-picker>
        </div>
        <div class="title-search-item">
          <el-button
            type="primary"
            plain
            size="mini"
            @click="addSchedule"
            v-showFunction="{
              active: 'add',
              array: allFunctionButtons,
            }"
            >新增日程</el-button
          >
        </div>
      </div>
    </div>
    <div class="flow-list" v-if="scheduleData.list.length > 0">
      <div
        class="flow-item"
        v-for="(item, index) in scheduleData.list"
        :key="index"
      >
        <div class="title" @click="showScheduleDetail(item)">
          {{ item.title }}
        </div>
        <div
          class="node"
          :class="[getStatusText(item.status)]"
          @click="showScheduleDetail(item)"
        ></div>
        <div class="time" @click="showScheduleDetail(item)">
          {{ item.startTime }} - {{ item.endTime }}
        </div>
        <div
          class="line-h"
          v-if="scheduleData.list.length !== index + 1"
          :class="getLineClass(item.status)"
        ></div>
      </div>
    </div>
    <div id="my-dialog" v-if="dialogData.flag">
      <my_dialog7
        :width="dialogData.width"
        :title="dialogData.title"
        :dialogStyle="dialogData.dialogStyle"
        :buttonArray="dialogData.buttonArray"
        :data="dialogData.data"
        @colseDialog="colseDialog"
        @dialogOper="drawerOper"
        @addProjectRecord="addProjectRecord"
      ></my_dialog7>
    </div>
  </div>
</template>

<script>
import * as taskData from "@/views/task/js/task.js";
export default {
  props: {
    scheduleData: {
      type: Object,
      default: () => ({
        date: [],
        list: [],
      }),
    },
    clientInfo: {
      type: Object,
      default: () => ({
        id: "",
      }),
    },
  },
  data() {
    return {
      baseInfo: {},
      centerDistanceList: [], // 存储每一组相邻节点中心距离
      dialogData: {
        flag: false,
        width: "30%",
        title: "查看支出附件",
        buttonArray: [
          {
            text: "取消",
            active: "cancel",
          },
        ],
        data: [
          {
            title: "",
            type: "show_img",
            value: "",
          },
        ],
        dialogStyle: {},
      },
      tempData: {},
      searchData: {
        userList: [],
        allRoleList: [],
        allUserList: [],
        allDepartTreeData: [],
        departTreeData: [],
      },
      clientDrawerOptions: {
        workList: [],
      },
      allFunctionButtons: this.$featureData.getAllFunctionButtons("taskInfo"),
    };
  },
  methods: {
    getModelFeatureAuthority() {
      console.log("获取权限");
      this.$authority.getModelFeatureAuthority(
        this,
        "taskInfo",
        this.allFunctionButtons,
        (data) => {
          this.allFunctionButtons = data;
          this.getDepartmentList();
          this.getDepartmentTreeByUserId();
        },
      );
    },
    /**
     * 获取所有部门列表
     */
    getDepartmentList() {
      let requestData = {
        companyId: this.baseInfo.company.companyId,
      };
      this.$request(
        "post",
        "/department/getDepartmentTree",
        requestData,
        (data) => {
          this.searchData.allDepartTreeData = [data];
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    /**
     * 获取部门树
     */
    getDepartmentTreeByUserId() {
      let requestData = {
        companyId: this.baseInfo.company.companyId,
        userId: this.baseInfo.userId,
      };
      this.$request(
        "post",
        "/department/getDepartmentTreeByUserId",
        requestData,
        (data) => {
          this.searchData.departTreeData = data;
          this.getEmployeeListByUserId();
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    /**
     * 获取所有下属列表 包括自己
     */
    getEmployeeListByUserId() {
      let requestData = {
        companyId: this.baseInfo.company.companyId,
        userId: this.baseInfo.userId,
        isDiMission: false,
        search: "",
      };
      this.$request(
        "post",
        "/user/getEmployeeListByUserId",
        requestData,
        (data) => {
          this.searchData.userList = JSON.parse(JSON.stringify(data));
          this.getBusinessAuthorityList();
          this.getEmployeeListForDownBox();
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    /**
     * 获取所有业务角色
     */
    getBusinessAuthorityList() {
      let requestData = {
        companyId: this.baseInfo.company.companyId,
      };
      this.$request(
        "post",
        "/role/getBusinessAuthorityList",
        requestData,
        (data) => {
          this.searchData.allRoleList = [];
          data.forEach((element) => {
            let dd = {
              label: element.authorityName,
              value: element.authorityId,
            };
            this.searchData.allRoleList.push(dd);
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    /**
     * 获取所有人员列表
     */
    getEmployeeListForDownBox() {
      let requestData = {
        companyId: this.baseInfo.company.companyId,
      };
      this.$request(
        "post",
        "/user/getEmployeeListForDownBox",
        requestData,
        (data) => {
          this.searchData.allUserList = data;
          this.$tagData.getTagList(
            this.clientDrawerOptions,
            ["日程事项"],
            this.baseInfo.company.companyId,
            this,
          );
        },
      );
    },
    // 连接线状态样式
    getLineClass(status) {
      const statusText = this.getStatusText(status);
      return {
        "line-wait": statusText === "wait",
        "line-process": statusText === "process",
        "line-finish": statusText === "finish",
        "line-overdue": statusText === "overdue",
      };
    },
    // 状态映射：将数字枚举转换为字符串状态
    getStatusText(status) {
      const statusMap = {
        1: "wait",
        2: "process",
        3: "finish",
        4: "overdue",
      };
      return statusMap[status] || "wait";
    },
    addSchedule() {
      this.dialogData.width = "600px";
      this.dialogData.title = "新增日程";
      this.dialogData.buttonArray = [
        {
          text: "确认",
          active: "sure_add",
        },
        {
          text: "取消",
          active: "cancel",
        },
      ];
      let options = {
        visibleUsersList: this.searchData.allUserList, // 下拉选项 可选人员列表
        businessRoleList: this.searchData.allRoleList, // 下拉选项 可选业务角色列表
        workList: this.clientDrawerOptions.workList, // 下拉选项 可选工作列表
        departmentList: this.searchData.allDepartTreeData, // 下拉选项 可选部门List,
      };
      this.dialogData.data = taskData.addScheduleDialog(options, true);
      this.dialogData.flag = true;
    },
    // 查看日程详情
    showScheduleDetail(item) {
      this.tempData = item;
      this.dialogData.width = "950px";
      this.dialogData.title = "日程详情";
      this.dialogData.buttonArray = [];
      this.$request(
        "get",
        "/scheduleFollowRecords/listBySchedule?scheduleId=" + this.tempData.id,
        {},
        (data) => {
          this.$request(
            "get",
            "/scheduleFollowRecords/detail?id=" + this.tempData.id,
            {},
            (data2) => {
              this.tempData.participants = data2.participants;
              this.dialogData.data = [
                {
                  type: "table_payroll",
                  data: {
                    model: "task",
                    recordData: {
                      title: "",
                      list: data, // 日程跟进记录
                    },
                    rowInfo: this.tempData,
                    searchData: [
                      {
                        type: "department",
                        key: "department",
                        options: this.searchData.departTreeData,
                      },
                      {
                        type: "employeeList",
                        key: "tempUserId",
                        options: this.searchData.userList,
                      },
                      {
                        type: "select",
                        key: "status",
                        placeholder: "请选择状态",
                        options: [
                          {
                            label: "未完成",
                            value: "未完成",
                          },
                          {
                            label: "已完成",
                            value: "已完成",
                          },
                        ],
                      },
                    ],
                    requestData: {
                      scheduleId: this.tempData.id, // 日程 id
                      clientName: "", // 客户名称
                      department: "", // 部门 id
                      tempUserId: this.baseInfo.userId,
                      status: "", // 日程状态
                      userIds: [this.baseInfo.userId], // 人员 id 集合
                    },
                    // optionsList: {
                    //   tempAllEmpolyeeList: this.tempAllEmpolyeeList,
                    // },
                    url: "/schedule/getExecutor",
                    tableMenuData: [
                      {
                        prop: "userName",
                        title: "姓名",
                      },
                      {
                        prop: "status",
                        title: "是否完成",
                      },
                      {
                        prop: "operation",
                        title: "操作",
                        width: "140px",
                        list: [
                          {
                            name: "完成",
                            active: "complete",
                            type: "success",
                            plain: true,
                            size: "mini",
                            icon: "el-icon-check",
                          },
                        ],
                      },
                    ],
                  },
                },
              ];
              this.dialogData.flag = true;
            },
            (errorMessage) => {
              this.$message.error(errorMessage);
            },
          );
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 添加记录
    addProjectRecord(textarea) {
      let requestData = {
        scheduleId: this.tempData.id, // 日程 id
        userId: this.baseInfo.userId, // 创建人id
        content: textarea,
      };
      if (requestData.content == "") {
        return this.$message.error("请输入记录内容!");
      }
      this.$request(
        "post",
        "/scheduleFollowRecords/add",
        requestData,
        (data) => {
          this.$message.success("跟进记录添加成功!");
          this.getScheduleFollowRecords();
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 获取日程跟进记录
    getScheduleFollowRecords() {
      this.$request(
        "get",
        "/scheduleFollowRecords/listBySchedule?scheduleId=" + this.tempData.id,
        {},
        (data) => {
          this.dialogData.data[0].data.recordData.list = data;
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    drawerOper(active) {
      let requestData = {};
      switch (active) {
        case "sure_add":
          requestData = {
            createUserId: this.baseInfo.userId, // 创建人 id
            title: this.dialogData.data[0].value, // 日程名称
            playersType: this.dialogData.data[1].data.playersType, // 参与者类型（'1'-人员；'2'-角色）
            visibleUsers: this.dialogData.data[1].data.visibleUsers, // 具体可见用户集合（JSON字符串），如果参与者类型是 '1' 则该字段必填
            businessRole: this.dialogData.data[1].data.businessRole, // 选择的业务角色
            clientCondition: this.dialogData.data[1].data.clientCondition, // 客户范围的筛选条件信息（JSON字符串）
            departmentIds: this.dialogData.data[1].data.departmentIds, // 选择的部门
            time: this.dialogData.data[2].value, // 日程时间
            repeatRule: this.dialogData.data[3].value, // 重复规则（不重复、每月）
            completeMethod: this.dialogData.data[4].value, // 完成方式：'1' - 逐步完成 '2' - 同步完成
            remind: this.dialogData.data[5].value, // 推送提醒
            content: this.dialogData.data[6].value, // 任务内容
            clientIds: [this.clientInfo.id], // 客户 id 集合 只在客户抽屉里有
          };
          if (!requestData.title) {
            return this.$message.error("日程名称不可为空!");
          }
          if (requestData.time.length == 0) {
            return this.$message.error("日程时间不可为空!");
          }
          if (requestData.playersType == "1") {
            if (requestData.visibleUsers.length == 0) {
              return this.$message.error("可见用户不可为空!");
            }
          } else if (requestData.playersType == "2") {
            if (requestData.businessRole.length == 0) {
              return this.$message.error("业务角色不可为空!");
            }
          } else if (requestData.playersType == "3") {
            if (requestData.departmentIds.length == 0) {
              return this.$message.error("部门不可为空!");
            }
          }
          requestData.departmentIds = JSON.stringify(requestData.departmentIds);
          requestData.businessRole = JSON.stringify(requestData.businessRole);
          requestData.visibleUsers = JSON.stringify(requestData.visibleUsers);
          requestData.clientCondition = JSON.stringify(
            requestData.clientCondition,
          );
          requestData.clientIds = JSON.stringify(requestData.clientIds);
          this.$request(
            "post",
            "/schedule/add",
            requestData,
            (data) => {
              this.$message.success("添加成功!");
              this.dialogData.flag = false;
              this.getScheduleList();
            },
            (errorMessage) => {
              this.$message.error(errorMessage);
            },
          );
          break;
        case "cancel":
          this.colseDialog();
          break;
      }
    },
    colseDialog() {
      this.dialogData.flag = false;
      if (this.dialogData.title == "日程详情") {
        this.getScheduleList();
      }
    },
    getScheduleList() {
      this.$emit("getScheduleList");
    },
  },
  async mounted() {
    this.baseInfo = JSON.parse(sessionStorage.getItem("userData"));
    this.getModelFeatureAuthority();
  },
};
</script>

<style lang="less" scoped>
/* 横向布局 */
.flow-wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 100%;
  margin: 0 auto;
  padding: 20px 24px;
  box-sizing: border-box;

  .flow-title {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 500;
    font-size: 16px;
    letter-spacing: 0.5px;

    .title-search {
      display: flex;
      .title-search-item {
        max-width: 200px;
        margin-left: 5px;
        /deep/ .el-button--mini,
        /deep/ .el-button--mini.is-round {
          padding: 8px 15px;
        }
      }
    }
  }

  .flow-list {
    width: 100%;
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
    box-sizing: border-box;
    margin-top: 20px;
    &::-webkit-scrollbar {
      height: 6px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: rgba(0, 0, 0, 0.2);
    }
    .flow-item {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-right: 100px;
      font-size: 13px;
      &:hover {
        color: #333;
      }
      .title {
        width: 130px;
        color: #334155;
        margin-bottom: 12px;
        text-align: center;
        // 超出部分省略号
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
      }

      /* 主节点基础 简约圆角 */
      .node {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        position: relative;
        z-index: 10;
        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        cursor: pointer;
        box-sizing: border-box;
        border: 2px solid transparent;
        background-clip: padding-box;
        &:hover {
          transform: scale(1.15);
          filter: brightness(1.1);
        }
      }
      .time {
        margin-top: 12px;
        font-size: 12px;
        color: #777e95;
        white-space: nowrap;
        cursor: pointer;
      }

      /* 连接线基础 */
      .line-h {
        position: absolute;
        width: 100%;
        height: 2px;
        transition: all 0.3s ease;
        border-radius: 1px;
        transform: translateX(0);
        top: 36px;
        left: 66px;
        // left: 17px;
        color: #fbbf24;
      }
      /* 首尾延伸线 */
      .line-extend {
        height: 2px;
        transition: all 0.3s ease;
        border-radius: 1px;
        position: absolute;
        top: 50%;
        width: 50%;
      }

      /* 首端延伸线 - 向左延伸至容器左侧 */
      .line-extend-start {
        right: 50%;
      }

      /* 末端延伸线 - 向右延伸至容器右侧 */
      .line-extend-end {
        left: 7%;
      }

      .wait {
        background-color: #f87171;
        border-color: #fca5a5;
      }
      .process {
        background-color: #f59e0b;
        border-color: #fbbf24;
      }
      .finish {
        background-color: #10b981;
        border-color: #34d399;
      }
      .overdue {
        background-color: #909399;
        border-color: #b0b3b9;
      }
      /* 连线跟随状态配色 */
      .line-wait {
        background-color: #f87171;
      }

      .line-process {
        background-color: #fbbf24;
        color: #fbbf24;
      }

      .line-finish {
        background-color: #67c23a;
      }
      .line-overdue {
        background-color: #909399;
        color: #909399;
      }
    }
  }
}
</style>
